import axios from 'axios'
import appConfig from '@/service/config'
import userService from '@/service/userService'
import moment from 'moment'

function fetchItems(itemsPage, search) {
  let params = {
    itemsPage: itemsPage,
    itemsSize: 10,
    storeId: userService.getCurrentStore(),
    countFromDate: moment().format('YYYY-MM-DD'),
    fetchComplainSearch: search
  }
  return axios({
     method: 'post',
     data: params,
     url: appConfig.baseUrl + '/complaints/fetchItems',
     headers: {
       Authorization: userService.getAuthHeader()
     }
   })
}

function addComplain(form) {
  let params = {
    storeId: userService.getCurrentStore(),
    createdBy: userService.getCurrentUser().name
  }
  return axios({
    method: 'post',
    url: appConfig.baseUrl + '/complaints/addComplain',
    data: {...form, ...params },
    headers: {
      Authorization: userService.getAuthHeader()
    }
  })
}

function fetchComplain(id) {
  let params = {
    id: id,
    storeId: userService.getCurrentStore()
  }
  return axios({
    method: 'post',
    url: appConfig.baseUrl + '/complaints/fetchComplain',
    data: params,
    headers: {
      Authorization: userService.getAuthHeader()
    }
  })
}

function deleteComplain(id) {
  let params = {
    id: id,
    storeId: userService.getCurrentStore()
  }
  return axios({
    method: 'post',
    url: appConfig.baseUrl + '/complaints/deleteComplain',
    data: params,
    headers: {
      Authorization: userService.getAuthHeader()
    }
  })
}

function deleteHistoryItem(id) {
  let params = {
    id: id
  }
  return axios({
    method: 'post',
    url: appConfig.baseUrl + '/complaints/deleteComplainHistoryItem',
    data: params,
    headers: {
      Authorization: userService.getAuthHeader()
    }
  })
}

function editComplain(params) {
  return axios({
    method: 'post',
    url: appConfig.baseUrl + '/complaints/editComplain',
    data: params,
    headers: {
      Authorization: userService.getAuthHeader()
    }
  })
}

function loadProductNames() {
  return axios({
    method: 'get',
    url: appConfig.baseUrl + "/product/allNames",
    headers: {
      Authorization: userService.getAuthHeader()
    }
  })
}

export default {
  "fetchItems": fetchItems,
  "addComplain": addComplain,
  "fetchComplain": fetchComplain,
  "editComplain": editComplain,
  "deleteComplain": deleteComplain,
  "loadProductNames": loadProductNames,
  "deleteHistoryItem": deleteHistoryItem
}



// WEBPACK FOOTER //
// ./src/components/complaints/ComplaintsRestClient.js